import { render } from "./App.vue?vue&type=template&id=56241fba&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=56241fba&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\LG\\Documents\\repositories\\opac\\search\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56241fba"]])

export default __exports__